module.exports = __webpack_public_path__ + "img/11招商加盟-img2_03.904b10e8.png";